import Vue from 'vue'
import VueUi from '@vue/ui'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@vue/ui/dist/vue-ui.css'

Vue.config.productionTip = false;

Vue.use(VueUi);

Vue.use(BootstrapVue);

new Vue({
    router,
    store,
    render: h => h(App),
    created() {
        this.$store.dispatch('getGraphData');
        this.$store.dispatch('getUserData');
    },

}).$mount('#app');
